import type { AddressValue } from "../types";

type Props = {
  id: string;
  label: string;
  value: AddressValue;
  onChange: (v: AddressValue) => void;
  required?: boolean;
};

const EMPTY: AddressValue = {
  line1: "",
  line2: "",
  suburb: "",
  state: "",
  postcode: "",
  country: "New Zealand",
};

export function emptyAddress(): AddressValue {
  return { ...EMPTY };
}

export function AddressInput({ id, label, value, onChange, required }: Props) {
  const v = value ?? EMPTY;
  const set = (patch: Partial<AddressValue>) => onChange({ ...v, ...patch });

  return (
    <fieldset className="subfield-set">
      <legend className="field-label">
        {label}
        {required && (
          <span className="req" aria-hidden="true">
            *
          </span>
        )}
      </legend>

      <div className="subfield">
        <label htmlFor={`${id}-line1`} className="subfield-label">
          Street address
        </label>
        <input
          id={`${id}-line1`}
          autoComplete="address-line1"
          value={v.line1}
          onChange={(e) => set({ line1: e.target.value })}
        />
      </div>

      <div className="subfield">
        <label htmlFor={`${id}-line2`} className="subfield-label">
          Apartment, unit, etc. <span className="subfield-optional">(optional)</span>
        </label>
        <input
          id={`${id}-line2`}
          autoComplete="address-line2"
          value={v.line2}
          onChange={(e) => set({ line2: e.target.value })}
        />
      </div>

      <div className="subfield">
        <label htmlFor={`${id}-suburb`} className="subfield-label">
          Suburb
        </label>
        <input
          id={`${id}-suburb`}
          autoComplete="address-level2"
          value={v.suburb}
          onChange={(e) => set({ suburb: e.target.value })}
        />
      </div>

      <div className="subfield-row">
        <div className="subfield">
          <label htmlFor={`${id}-state`} className="subfield-label">
            Region
          </label>
          <input
            id={`${id}-state`}
            autoComplete="address-level1"
            value={v.state}
            onChange={(e) => set({ state: e.target.value })}
          />
        </div>
        <div className="subfield">
          <label htmlFor={`${id}-postcode`} className="subfield-label">
            Postcode
          </label>
          <input
            id={`${id}-postcode`}
            inputMode="numeric"
            autoComplete="postal-code"
            value={v.postcode}
            onChange={(e) => set({ postcode: e.target.value })}
          />
        </div>
      </div>

      <div className="subfield">
        <label htmlFor={`${id}-country`} className="subfield-label">
          Country
        </label>
        <input
          id={`${id}-country`}
          autoComplete="country-name"
          value={v.country}
          onChange={(e) => set({ country: e.target.value })}
        />
      </div>
    </fieldset>
  );
}
